import { Form, Input } from "antd";
import { Wizard } from "@/components/wizard";

interface ProvideInputModalProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (text: string) => void;
}

/** Drawer wizard for providing the input a task is waiting on. */
export function ProvideInputModal({
	open,
	onClose,
	onSubmit,
}: ProvideInputModalProps) {
	const [form] = Form.useForm<{ text: string }>();

	const handleComplete = () => {
		form.validateFields().then(({ text }) => {
			onSubmit(text);
			form.resetFields();
			onClose();
		});
	};

	const handleCancel = () => {
		form.resetFields();
		onClose();
	};

	return (
		<Wizard
			open={open}
			title="Provide Input"
			completeLabel="Submit"
			form={form}
			onComplete={handleComplete}
			onCancel={handleCancel}
			pages={[
				{
					id: "input",
					title: "Input",
					content: (
						<Form.Item
							name="text"
							label="Input"
							rules={[{ required: true, message: "Input is required" }]}
						>
							<Input.TextArea
								rows={4}
								placeholder="Enter the requested input"
							/>
						</Form.Item>
					),
				},
			]}
		/>
	);
}
